import { PageHeader } from "../../components/Header";
import { PageFooter } from "../../components/Footer";
import { DialogHeader } from "../../components/Header";
import LateralityButton from "./LateralityButton";
import useLaterality from "./hooks/useLaterality";
import useLang from "../../hooks/useLang";
import Button from "../../components/Button";

const Laterality = (props) => {
  const {
    bButtonAttribs,
    rButtonAttribs,
    mButtonAttribs,
    lButtonAttribs,
    fButtonAttribs,
    showBackButton,
    backButtonAttribs,
  } = useLaterality(props);
  const lang = useLang();

  return (
    <>
      <PageHeader {...props?.header} />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <DialogHeader title={`${props?.frequency} Hz`} centered />
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <LateralityButton {...bButtonAttribs} />
        <div
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <LateralityButton {...rButtonAttribs} />
          <LateralityButton {...mButtonAttribs} />
          <LateralityButton {...lButtonAttribs} />
        </div>
        <LateralityButton {...fButtonAttribs} />
      </div>
      {showBackButton ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            margin: "var(--padding-article-header)",
          }}
        >
          <Button {...backButtonAttribs}>{lang("captions.undo")}</Button>
        </div>
      ) : null}
      <PageFooter {...props?.footer} />
    </>
  );
};

export default Laterality;
